import type React from 'react';
import { useEffect, useRef, useState } from 'react';

import { Tooltip, TooltipArrow, TooltipContent, TooltipProvider, TooltipTrigger } from '@/ui/Tooltip';

type TooltipWrapperProps = React.PropsWithChildren<{
  tooltipText: string;
  portalId: string;
  isTriggerAsChild?: boolean;
  shouldMount?: boolean;
}>;

export const TooltipWrapper = ({
  tooltipText,
  portalId,
  children,
  isTriggerAsChild = true,
  shouldMount = true,
}: TooltipWrapperProps) => {
  const container = useRef<HTMLElement | null>(null);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const el = document.getElementById(portalId);
    if (el) {
      container.current = el;
    }
    setIsMounted(true);
  }, [portalId]);

  if (!isMounted || !shouldMount) {
    return <>{children}</>;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild={isTriggerAsChild}>{children}</TooltipTrigger>
        {/* @ts-expect-error container ref isn't really null */}
        <TooltipContent container={container}>
          <div className="px-2 py-1 text-sm text-white bg-gray-800 rounded">{tooltipText}</div>
          <TooltipArrow />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
